import { css } from 'linaria'
import * as layoutStyles from '../../../components/layout/layout.styles'

// padding left/right to not change spacing for border from balanceWrapper
// padding top/bottom to extend the border slightly larger
// margin top/bottom to add spacing and include border
export const section = css`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 0.25rem;
  padding-top: 0.25rem;
  width: 100%;
  min-height: 0px;

  ${layoutStyles.breakpointSmall} {
    min-height: 150px;
  }
`

export const money = css`
  white-space: nowrap;
`

const spaceBetweenStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between'
}

export const spaceBetween = css`
  ${spaceBetweenStyle};
  padding-bottom: 0.5em
`

export const subText = css`
  font-size: 0.75rem;
  color: #707070;
  font-weight: normal;
`

export const bold = css`
  font-weight: 700;
`

export const headerRow = css`
  ${spaceBetweenStyle};
  margin-bottom: 0.5rem;

  ${layoutStyles.breakpointSmall} {
    margin-bottom: 2rem;
  }
`

export const buttonContainer = css`
  margin-bottom: 0.5rem;
`

export const emptySpace = css`
  width: 100%
`
